module.exports = {
      id: "fallback-image-usage",
      viewBox: "0 0 102 76",
      url: __webpack_public_path__ + "svg-sprite-b11c226f9ecc9a258e9645c9abf2e2fd.svg#fallback-image",
      toString: function () {
        return this.url;
      }
    }